import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom' // Make sure this is imported
import { TableComp } from 'sz-react-utils-lite'
import {
    displayDate
} from '../../components/_utils/appUtils'
import { getPackageListFxn } from './actions'
import { Icon, Tooltip } from 'antd'
import { ColumnWidth } from '../WebComponent/columnWidth'

const EsimPackagesList = () => {
    let [filters, setFilters] = useState({})
    const tableRef = useRef()
    const dispatch = useDispatch()
    const history = useHistory() // Add this line if not already present
    const apiRequest = params => {
        return new Promise(async resolve => {
            params.results = 100
            params.count = 100

            let data = await dispatch(getPackageListFxn({ ...params }))
            resolve(data)
        })
    }

    // Add navigation function
    const handleViewDetails = (record) => {

        const packageResponse = record.response || {};

        const packageData = {
            package_id: record.request.package_id || '',
            data: record.request.data || '5',
            amount: record.request.amount || '0',
            day: record.request.day || '14',
            country_id: record.request.country_id || 'al'
        };

        const customerData = {
            email: record.request.email || '',
            firstName: record.request.firstname || '',
            lastName: record.request.lastname || '',
            homeCountry: record.request.origin_country_code || '',
            cardHolderName: record.request.cardHolderName || ''
        };

        const quantity = record.request.quantity || 1
        const total = parseFloat(record.request.amount || 0) * quantity

        /*        history.push('/esim-success', {
                    packageResponse: packageResponse,
                    packageData: packageData,
                    quantity: quantity,
                    total: total,
                    customerData: customerData
                });*/

        history.push(`/esim-success/${record._id}`)

    };

    const columns = [
        {
            title: 'Se. No.',
            dataIndex: 'index',
            key: 'index',
            width: 70,
            render: (val, record, index) => {
                return index + 1
            }
        },
        {
            title: 'Email',
            dataIndex: ['request', 'email'],
            key: 'email',
            width: 200,
            render: (val) => val || '-'
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            render: (val, record) => {
                const firstName = record.request.firstname || ''
                const lastName = record.request.lastname || ''
                return `${firstName} ${lastName}`.trim() || '-'
            }
        },
        {
            title: 'Agent',
            key: 'userId',
            dataIndex: 'userId',
            width: 150,
            render: item => {
                return (
                  <ColumnWidth width={150}>
                      {item && item.name ? item.name : ''}
                      {item && item.companyName ? ` (${item.companyName})` : ''}
                  </ColumnWidth>
                )
            }
        },
        {
            title: 'Package ID',
            dataIndex: ['request', 'package_id'],
            key: 'package_id',
            render: (val) => val || '-'
        },

        {
            title: 'Status',
            dataIndex: ['response', 'success'],
            key: 'status',
            render: (val) => {
                return val ? (
                    <span className="badge bg-success">Success</span>
                ) : (
                    <span className="badge bg-danger">Failed</span>
                )
            }
        },
        {
            title: 'ICCID',
            dataIndex: ['response', 'esim', 'iccid'],
            key: 'iccid',
            render: (val) => val || '-'
        },
        {
            title: 'Phone Number',
            dataIndex: ['response', 'esim', 'msisdn'],
            key: 'msisdn',
            width: 130,
            render: (val) => val || '-'
        },

        {
            title: 'Date Created',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 150,
            render: (val) => val ? displayDate(val) : '-'
        },
        {
            key: 'actions',
            title: 'Actions',
            height: 100,
            render: (text, record) => {
                return (
                  <div>
                      <Tooltip title={'View E-SIM'}>
                          <a className={'btn btn-default roundNew md'}
                             onClick={() => handleViewDetails(record)}>
                              <Icon type='eye' />
                          </a>
                      </Tooltip>
                  </div>
                )
            }
        }
    ]

    return (
        <div className="row mt-4">
            <div className="col-lg-12">
                <div className="card">
                    <div className="table-head d-flex align-items-center">
                        <h5>Esim Package List</h5>
                    </div>
                    <div className="card-body table-responsive">
                        <TableComp
                            columns={columns}
                            apiRequest={apiRequest}
                            ref={tableRef}
                            pagination={{
                                position: 'top',
                                showSizeChanger: true,
                                pageSizeOptions: ['20', '20', '50', '100'],
                                defaultPageSize: 20,
                                current: filters.page ? filters.page : 1
                            }}
                            // extraProps={{ scroll: { x: 600 } }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EsimPackagesList
